import * as React from "react";
import { CompanySummary } from "../../../../../../Wrap/Models/Models/Company/CompanySummary";
import { IAddClientModel } from "../../../Clients/AddClient/Components/AddClientWizard";
import { Filter } from "../../../Clients/AddClient/Components/ClientType/Filter";

interface ISearchProps {
    onChangeFirmHierarchyId: (firmHierarchyId: CompanySummary) => void;
}

const Search = (props: ISearchProps) => {
    const filterRef = React.useRef<any>();
    const [filterState, setFilterState] = React.useState<{
        firm: CompanySummary;
        networkName: string;
    }>({
        firm: null,
        networkName: null,
    });

    return (
        <>
            <Filter
                data={null}
                excludeAdviser
                onRef={(ref) => {
                    filterRef.current = ref;
                }}
                onFilterSelectionChange={onChangeFilterSelection}
                onOneDefaultCompany={(company) => props.onChangeFirmHierarchyId(company)}
                onChange={() => {}}
            />

            <button className="btn secondary" onClick={onClickUpdate}>
                Update
            </button>
        </>
    );

    function onClickUpdate() {
        if (filterRef.current?.isValid()) {props.onChangeFirmHierarchyId(filterState.firm);}
    }

    function onChangeFilterSelection(value: IAddClientModel) {
        if (value?.SelectedFirm) {
            setFilterState({
                firm: value?.SelectedFirm,
                networkName: value?.SelectedNetwork?.NetworkName,
            });
        }
    }
};

export default Search;
